export default class InViewDetector {
    constructor(selector, callback, options = {}) {
        this.elements = $(selector)
        this.callback = callback
        this.options = options
        this.init()
    }

    init() {
        const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
            root: this.options.root || null,
            rootMargin: this.options.rootMargin || '0px',
            threshold: this.options.threshold || 0.5
        })

        this.elements.each((i, el) => observer.observe(el))
    }

    handleIntersect(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) setTimeout(() => this.callback(), this.options.delay || 0)
        });
    }
}